import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useLanguageContext } from "../context/languageContext";

import { Data } from "../types/api";
export const useMainQuery = () => {
  const { language } = useLanguageContext();

  return useQuery(["query", language], () =>
    language === "PL"
      ? axios.get<Data>(process.env.REACT_APP_API_QUERYURL!)
      : axios.get<Data>(process.env.REACT_APP_API_QUERYURL_EN!)
  );
};
